'use strict';

export default function LoadingItems({}) {
    return <React.Fragment>
        <div className="flight is-loading"></div>
        <div className="flight is-loading"></div>
        <div className="flight is-loading"></div>
        <div className="flight is-loading"></div>
        <div className="flight is-loading"></div>
    </React.Fragment>
}
